import React from 'react';

import FanzoneRecommend from '../FanzoneRecommend/FanzoneRecommend';


function PaymentError(props) {

  return (
    <div className="calendar-checkout-container">
      <h1 className="calendar-checkout-title">Thank you for your interest!</h1>
      <p className="calendar-checkout-text">
        Unfortunately something went wrong and your purchase did not go through
        as expected. Please check your bank statement to see if any money was
        taken from your balance. If not you can{' '}
        <a href="/calendar-purchase">retry purchasing</a> or if you have any
        questions or comments you can <a href="/contact">contact us</a>.
      </p>
      <FanzoneRecommend anchorId={props.anchorId} failed={true} />
    </div>
  );
}

export default PaymentError;
